/* Outpost Theme 7 — colour switching and photo cycling for product cards, the product page,
   the men's / women's switch, product recommendations, filter/sort auto-submit and predictive search.
   Data comes from snippets/color-media.liquid (the single colour→media mapping);
   this file never decides which image belongs to which colour. */
(function () {
  'use strict';

  var MONEY = window.OutpostMoneyFormat || '${{amount}}';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var n = Number(cents) || 0;
    var fixed = (n / 100).toFixed(2);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return whole;
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return whole + '.' + parts[1];
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return url;
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function srcset(url, widths) {
    return widths.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  // Mirrors snippets/price.liquid.
  function priceHtml(price, compare, from) {
    var now = (from ? 'From ' : '') + money(price);
    if (compare && compare > price) {
      return '<span class="price price--sale"><span class="vh">Sale price</span><span class="price__now">' + now +
        '</span><span class="vh">Regular price</span><s class="price__was">' + money(compare) + '</s></span>';
    }
    return '<span class="price"><span class="price__now">' + now + '</span></span>';
  }

  function parseJson(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // False once the men's / women's switch has swapped this element out of the page.
  function attached(el) {
    return document.documentElement.contains(el);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ------------------------------------------------------------------ cards */

  function cardData(card) {
    if (card.__outpostColors === undefined) {
      card.__outpostColors = parseJson(card.querySelector('script[data-color-json]'));
    }
    return card.__outpostColors;
  }

  // The selected colour's gallery, in display order, limited to media the card can show.
  function cardGallery(card) {
    var data = cardData(card);
    if (!data) return [];
    if (card.__outpostColor === undefined) card.__outpostColor = data.selected || 0;
    var color = data.colors[card.__outpostColor];
    var media = data.media || {};
    return ((color && color.g) || []).filter(function (id) { return media[id]; });
  }

  // Even out photo sizes (2026-10-02, Craig: some products looked tiny, some came in grey boxes).
  // f = [x0, y0, x1, y1, '#bg']: the product's box inside the photo (fractions) and the photo's plain border
  // colour, measured once per photo. Scale so the product fills ~92% of the tile, centred, never clipping it;
  // a non-white border colours the tile so the photo's own grey box disappears.
  var FRAME_FILL = 0.92, FRAME_MAX = 2.5;
  function frameCardImage(img, f) {
    var box = img.parentElement;
    img.style.transform = '';
    if (box) { box.style.background = ''; }
    img.style.mixBlendMode = '';
    if (!f || f.length < 4 || !box) return;
    var bw = img.clientWidth, bh = img.clientHeight;
    var nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    if (!bw || !bh || !nw || !nh) return;
    var ar = nw / nh, dw, dh;
    if (ar > bw / bh) { dw = bw; dh = bw / ar; } else { dh = bh; dw = bh * ar; }
    var pw = (f[2] - f[0]) * dw, ph = (f[3] - f[1]) * dh;
    if (pw <= 0 || ph <= 0) return;
    var s = Math.min(FRAME_FILL * bw / pw, FRAME_FILL * bh / ph, FRAME_MAX);
    if (s < 1) s = 1;
    var cx = ((f[0] + f[2]) / 2 - 0.5) * dw, cy = ((f[1] + f[3]) / 2 - 0.5) * dh;
    if (s > 1.02 || Math.abs(cx) > 2 || Math.abs(cy) > 2) {
      img.style.transform = 'translate(' + (-cx * s).toFixed(1) + 'px,' + (-cy * s).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
    }
    var bg = String(f[4] || '');
    if (/^#[0-9a-f]{6}$/i.test(bg) && bg.toLowerCase() !== '#ffffff') {
      var r = parseInt(bg.substr(1, 2), 16), g = parseInt(bg.substr(3, 2), 16), b = parseInt(bg.substr(5, 2), 16);
      if (Math.min(r, g, b) < 248) { box.style.background = bg; img.style.mixBlendMode = 'normal'; }
    }
  }
  function frameFromAttr(img) {
    var raw = img.getAttribute('data-frame');
    if (!raw) { frameCardImage(img, null); return; }
    try { frameCardImage(img, JSON.parse(raw)); } catch (e) { frameCardImage(img, null); }
  }
  function initFrames(scope) {
    var imgs = (scope || document).querySelectorAll('img[data-card-img][data-frame]');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.__outpostFramed) { frameFromAttr(img); return; }
        img.__outpostFramed = true;
        if (img.complete) frameFromAttr(img);
        img.addEventListener('load', function () { frameFromAttr(img); });
      })(imgs[i]);
    }
  }
  var frameTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(frameTimer);
    frameTimer = setTimeout(function () { initFrames(document); }, 150);
  });

  // Swapping src keeps the old image on screen until the new one has loaded.
  function showCardImage(card, id) {
    var data = cardData(card);
    var m = data && data.media && data.media[id];
    var img = card.querySelector('[data-card-img]');
    if (!m || !img) return;
    if (m.f) img.setAttribute('data-frame', JSON.stringify(m.f)); else img.removeAttribute('data-frame');
    img.srcset = srcset(m.u, [360, 600, 900]);
    img.src = sized(m.u, 600);
    if (m.w && m.h) { img.width = m.w; img.height = m.h; }
    if (!img.__outpostFramed) { img.__outpostFramed = true; img.addEventListener('load', function () { frameFromAttr(img); }); }
    frameFromAttr(img);
    var owner = null;
    for (var c = 0; c < (data.colors || []).length; c++) if ((data.colors[c].g || []).indexOf(id) > -1) { owner = data.colors[c].v; break; }
    img.alt = colourAlt(m.alt || data.title, owner);
  }

  // Alt text names the colour the photo shows, for image search, unless it already does.
  function colourAlt(alt, colour) {
    alt = String(alt).replace(/ in Default$/i, '');
    var c = String(colour || '').toLowerCase();
    if (!c || c === 'default' || c === 'default title' || String(alt).toLowerCase().indexOf(c) > -1) return alt;
    return alt + ' in ' + colour;
  }

  // Fetch one image ahead so the next arrow press or swipe is instant.
  function warmCardImage(card, id) {
    var data = cardData(card);
    var m = data && data.media && data.media[id];
    var img = card.querySelector('[data-card-img]');
    card.__outpostWarm = card.__outpostWarm || {};
    if (!m || !img || card.__outpostWarm[id]) return;
    card.__outpostWarm[id] = true;
    var pre = new Image();
    pre.sizes = img.sizes;
    pre.srcset = srcset(m.u, [360, 600, 900]);
    pre.src = sized(m.u, 600);
  }

  function renderCardCycle(card, ids, at) {
    var box = card.querySelector('[data-card-cycle]');
    if (!box) return;
    box.hidden = ids.length < 2;
    var dots = box.querySelector('[data-card-dots]');
    if (!dots) return;
    dots.classList.toggle('card-cycle__dots--dense', ids.length > 8);
    dots.innerHTML = ids.map(function (_, i) {
      return '<i class="card-cycle__dot' + (i === at ? ' is-on' : '') + '"></i>';
    }).join('');
  }

  function stepCard(card, delta) {
    var ids = cardGallery(card);
    if (ids.length < 2) return false;
    var at = ((card.__outpostAt || 0) + delta + ids.length) % ids.length;
    card.__outpostAt = at;
    showCardImage(card, ids[at]);
    renderCardCycle(card, ids, at);
    warmCardImage(card, ids[(at + delta + ids.length) % ids.length]);
    var live = card.querySelector('[data-card-count]');
    if (live) live.textContent = 'Image ' + (at + 1) + ' of ' + ids.length;
    return true;
  }

  // A card may render only its in-stock swatches, so a button's position in the list is no
  // longer its row in data.colors. The row travels on the button as data-color-index.
  function swatchRow(btn, fallback) {
    var a = btn && btn.getAttribute && btn.getAttribute('data-color-index');
    return a === null || a === undefined || a === '' ? fallback : parseInt(a, 10);
  }

  function selectCardColor(card, index, focus) {
    var data = cardData(card);
    if (!data || !data.colors[index]) return;
    var color = data.colors[index];
    var buttons = card.querySelectorAll('[data-swatch]');
    for (var i = 0; i < buttons.length; i++) {
      var on = swatchRow(buttons[i], i) === index;
      buttons[i].setAttribute('aria-checked', on ? 'true' : 'false');
      buttons[i].tabIndex = on ? 0 : -1;
      buttons[i].classList.toggle('is-selected', on);
      if (on && focus) buttons[i].focus();
    }
    card.__outpostColor = index;
    card.__outpostAt = 0;
    var ids = cardGallery(card);
    if (ids.length) showCardImage(card, ids[0]);
    renderCardCycle(card, ids, 0);
    if (ids.length > 1) warmCardImage(card, ids[1]);
    var live = card.querySelector('[data-card-count]');
    if (live) live.textContent = '';
    if (color.id) {
      var href = data.url + (data.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + color.id + '&pick=color';
      var links = card.querySelectorAll('[data-card-link]');
      for (var j = 0; j < links.length; j++) links[j].href = href;
    }
    var price = card.querySelector('[data-card-price]');
    if (price) price.innerHTML = priceHtml(color.p, color.c, color.pmin !== color.pmax);
    var label = card.querySelector('[data-color-label]');
    if (label) label.textContent = color.v;
    var status = card.querySelector('[data-color-status]');
    if (status) status.textContent = color.a ? '' : 'Sold out';
    card.classList.toggle('is-soldout', !color.a);
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-color-card] [data-card-step]');
    if (step) {
      e.preventDefault();
      stepCard(step.closest('[data-color-card]'), Number(step.getAttribute('data-card-step')));
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-color-card] [data-swatch]');
    if (!btn) return;
    e.preventDefault();
    var list = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-swatch]'));
    selectCardColor(btn.closest('[data-color-card]'), swatchRow(btn, list.indexOf(btn)), false);
  });

  // Pointing at a card fetches its second image, so the first arrow press is instant.
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('[data-color-card]');
    if (!card || card.__outpostHovered) return;
    card.__outpostHovered = true;
    var ids = cardGallery(card);
    if (ids.length > 1) warmCardImage(card, ids[1]);
  });

  // Horizontal swipe on a card image cycles its photos; vertical movement scrolls the page.
  var cardTouch = null;
  document.addEventListener('touchstart', function (e) {
    var media = e.target.closest && e.target.closest('[data-color-card] [data-card-media]');
    if (!media || e.touches.length !== 1 || e.target.closest('[data-card-step]')) { cardTouch = null; return; }
    var card = media.closest('[data-color-card]');
    cardTouch = { x: e.touches[0].clientX, y: e.touches[0].clientY, card: card };
    var ids = cardGallery(card);
    if (ids.length > 1) warmCardImage(card, ids[((card.__outpostAt || 0) + 1) % ids.length]);
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!cardTouch) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - cardTouch.x;
    var dy = t.clientY - cardTouch.y;
    var card = cardTouch.card;
    cardTouch = null;
    if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    if (stepCard(card, dx < 0 ? 1 : -1)) card.__outpostSwiped = Date.now();
  }, { passive: true });
  document.addEventListener('touchcancel', function () { cardTouch = null; }, { passive: true });
  // A swipe must never also open the product.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-color-card] [data-card-media] a');
    if (!link) return;
    var card = link.closest('[data-color-card]');
    if (card.__outpostSwiped && Date.now() - card.__outpostSwiped < 450) {
      e.preventDefault();
      card.__outpostSwiped = 0;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('[data-color-card] [data-swatch]');
    if (!btn) return;
    var list = Array.prototype.slice.call(btn.parentNode.querySelectorAll('[data-swatch]'));
    var i = list.indexOf(btn);
    var next;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % list.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + list.length) % list.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = list.length - 1;
    else if (e.key === ' ' || e.key === 'Enter') next = i;
    else return;
    e.preventDefault();
    selectCardColor(btn.closest('[data-color-card]'), swatchRow(list[next], next), true);
  });

  /* --------------------------------------------------------------- gallery */

  function initGallery(root) {
    if (!root || root.__outpostGallery) return;
    root.__outpostGallery = true;
    var track = root.querySelector('[data-gallery-track]');
    var count = root.querySelector('[data-gallery-count]');
    var ticking = false;

    function slides() { return track.querySelectorAll('[data-slide]'); }
    function current() { return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function sync() {
      var n = slides().length;
      var i = Math.min(current(), Math.max(n - 1, 0));
      if (count) count.textContent = (n ? i + 1 : 0) + ' / ' + n;
      var thumbs = root.querySelectorAll('[data-thumb]');
      for (var t = 0; t < thumbs.length; t++) thumbs[t].setAttribute('aria-current', t === i ? 'true' : 'false');
    }
    function go(i) {
      var n = slides().length;
      if (!n) return;
      i = Math.max(0, Math.min(i, n - 1));
      track.scrollTo({ left: i * track.clientWidth, behavior: REDUCED ? 'auto' : 'smooth' });
    }
    root.__go = go;
    root.__sync = sync;

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-gallery-prev]')) go(current() - 1);
      else if (e.target.closest('[data-gallery-next]')) go(current() + 1);
      else {
        var th = e.target.closest('[data-thumb]');
        if (th) go(Number(th.getAttribute('data-thumb')));
      }
    });
    window.addEventListener('resize', function () { if (attached(root)) go(current()); });
  }

  function renderGallery(root, ids, media, title, colour) {
    var gallery = root.querySelector('[data-gallery-root]');
    if (!gallery) return 0;
    var list = (ids || []).filter(function (id) { return id && media[id]; });
    if (!list.length) return 0; // keep what is rendered rather than show nothing
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbs = gallery.querySelector('[data-gallery-thumbs]');
    var nav = gallery.querySelector('[data-gallery-nav]');
    track.innerHTML = list.map(function (id, i) {
      var m = media[id];
      return '<figure class="pdp-gallery__slide" data-slide><img src="' + esc(sized(m.u, 1000)) + '" srcset="' +
        esc(srcset(m.u, [600, 1000, 1500, 2000])) + '" sizes="(min-width: 990px) 55vw, 100vw"' +
        (m.w ? ' width="' + m.w + '" height="' + m.h + '"' : '') + ' alt="' + esc(colourAlt(m.alt || title, colour)) + '"' +
        (i ? ' loading="lazy"' : '') + '></figure>';
    }).join('');
    thumbs.innerHTML = list.map(function (id, i) {
      return '<button type="button" class="pdp-gallery__thumb" data-thumb="' + i + '" aria-label="Show image ' + (i + 1) +
        '" aria-current="' + (i ? 'false' : 'true') + '"><img src="' + esc(sized(media[id].u, 160)) +
        '" alt="" width="72" height="72" loading="lazy"></button>';
    }).join('');
    var multi = list.length > 1;
    thumbs.hidden = !multi;
    if (nav) nav.hidden = !multi;
    track.scrollLeft = 0;
    if (gallery.__sync) gallery.__sync();
    return list.length;
  }

  /* ---------------------------------------------------------- product page */

  function initProduct(root) {
    var data = parseJson(root.querySelector('script[data-product-json]'));
    if (!data) return;
    var n = data.optionNames.length;
    var ci = data.colorIndex;
    var select = root.querySelector('[data-variant-select]');
    var atc = root.querySelector('[data-pdp-atc]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var statusEl = root.querySelector('[data-pdp-status]');
    var skuEl = root.querySelector('[data-pdp-sku]');
    var live = root.querySelector('[data-pdp-live]');
    var shownColor = null;

    initGallery(root.querySelector('[data-gallery-root]'));

    function inputs(i) { return root.querySelectorAll('input[data-option-input="' + i + '"]'); }
    function selected() {
      var out = [];
      for (var i = 0; i < n; i++) {
        var c = root.querySelector('input[data-option-input="' + i + '"]:checked');
        out.push(c ? c.value : null);
      }
      return out;
    }
    function fits(v, sel, skip) {
      for (var i = 0; i < n; i++) {
        if (i === skip || sel[i] === null) continue;
        if (v.o[i] !== sel[i]) return false;
      }
      return true;
    }
    function resolve(sel) {
      if (sel.indexOf(null) > -1) return null;
      for (var i = 0; i < data.variants.length; i++) if (fits(data.variants[i], sel, -1)) return data.variants[i];
      return null;
    }
    function colorRow(value) {
      for (var i = 0; i < data.colors.length; i++) if (data.colors[i].v === value) return data.colors[i];
      return data.colors[0] || null;
    }
    function labelFor(input) { return root.querySelector('label[for="' + input.id + '"]'); }

    function update(opts) {
      opts = opts || {};
      var sel = selected();

      // Which non-colour values can still be bought with the other choices?
      for (var i = 0; i < n; i++) {
        if (i === ci) continue;
        var ins = inputs(i);
        for (var k = 0; k < ins.length; k++) {
          var inp = ins[k];
          var exists = false;
          var avail = false;
          for (var v = 0; v < data.variants.length; v++) {
            var variant = data.variants[v];
            if (variant.o[i] === inp.value && fits(variant, sel, i)) {
              exists = true;
              if (variant.a) avail = true;
            }
          }
          inp.disabled = !avail;
          if (!exists && inp.checked) inp.checked = false;
          var lab = labelFor(inp);
          if (lab) {
            lab.classList.toggle('is-unavailable', !avail);
            lab.classList.toggle('is-missing', !exists);
            var sr = lab.querySelector('.vh');
            if (sr) sr.textContent = !exists ? ', not made in this color' : (!avail ? ', sold out' : '');
          }
        }
      }
      sel = selected();

      var variantNow = resolve(sel);
      var colorValue = ci > -1 ? sel[ci] : null;
      var color = ci > -1 ? colorRow(colorValue) : data.colors[0];

      if (ci > -1 && color && colorValue !== shownColor) {
        if (!opts.initial) {
          var shown = renderGallery(root, color.g, data.media, data.title, colorValue);
          if (live && shown) live.textContent = colorValue + ': ' + shown + (shown === 1 ? ' image' : ' images') + '.';
        }
        shownColor = colorValue;
      }

      var legends = root.querySelectorAll('fieldset[data-option-index]');
      for (var l = 0; l < legends.length; l++) {
        var idx = Number(legends[l].getAttribute('data-option-index'));
        var span = legends[l].querySelector('[data-option-value]');
        if (span) span.textContent = sel[idx] !== null ? sel[idx] : 'Select';
      }
      var note = root.querySelector('[data-color-note]');
      if (note) note.textContent = color && !color.a ? ' — sold out' : '';

      var missing = [];
      for (var m = 0; m < n; m++) if (sel[m] === null) missing.push(data.optionNames[m].toLowerCase());

      var status;
      var buttonText;
      var canBuy = false;
      if (variantNow) {
        canBuy = !!variantNow.a;
        status = variantNow.a ? 'In stock' : 'Sold out';
        buttonText = variantNow.a ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.innerHTML = priceHtml(variantNow.p, variantNow.c, false);
      } else {
        var dead = splitDead;
        status = color && !color.a ? 'Sold out in this color' : dead ? 'Sold out in this size' : 'Choose your ' + missing.join(' and ');
        buttonText = (color && !color.a) || dead ? 'Sold out' : 'Select ' + missing.join(' and ');
        if (priceEl && color) priceEl.innerHTML = priceHtml(color.pmin, null, color.pmin !== color.pmax);
      }
      if (atc) { atc.disabled = !canBuy; atc.textContent = buttonText; }
      if (statusEl) {
        statusEl.textContent = status;
        statusEl.classList.toggle('is-in', !!(variantNow && variantNow.a));
        statusEl.classList.toggle('is-out', !!((variantNow && !variantNow.a) || (color && !color.a)));
      }
      if (skuEl) {
        var sku = variantNow ? variantNow.sku : (color ? color.sku : '');
        skuEl.textContent = sku ? 'Style ' + sku : '';
      }
      if (select) select.value = variantNow ? String(variantNow.id) : '';

      if (!opts.noUrl && window.history && window.URL) {
        var url = new URL(window.location.href);
        if (variantNow) {
          url.searchParams.set('variant', variantNow.id);
          url.searchParams.delete('pick');
        } else if (color && color.id) {
          url.searchParams.set('variant', color.id);
          url.searchParams.set('pick', 'color');
        }
        if (url.toString() !== window.location.href) window.history.replaceState(window.history.state, '', url.toString());
      }
      syncSplit();
    }

    // Size + Width rows (snippets/size-width.liquid) drive the hidden combined option ("9.5 D").
    var splitSize = root.querySelector('[data-split-size]');
    var splitWidth = root.querySelector('[data-split-width]');
    var splitIndex = splitSize ? Number(splitSize.getAttribute('data-split-size')) : -1;
    function splitParts(value) {
      var m = /^(\S+)\s+(\S+)$/.exec(value || '');
      return m ? { s: m[1], w: m[2].toUpperCase() } : null;
    }
    var splitDead = false;
    function splitPicked(box) {
      var c = box.querySelector('input[data-split-input]:checked');
      return c ? c.value : null;
    }
    function splitReal() {
      var out = [];
      var ins = inputs(splitIndex);
      for (var k = 0; k < ins.length; k++) {
        var p = splitParts(ins[k].value);
        var lab = labelFor(ins[k]);
        if (p) out.push({ input: ins[k], s: p.s, w: p.w, made: !(lab && lab.classList.contains('is-missing')) });
      }
      return out;
    }
    function syncSplit() {
      if (!splitSize || !splitWidth) return;
      var real = splitReal();
      var chosen = null;
      for (var i = 0; i < real.length; i++) if (real[i].input.checked) chosen = real[i];
      if (chosen) splitDead = false;
      if (chosen) {
        var si = splitSize.querySelector('input[value="' + chosen.s + '"]');
        var wi = splitWidth.querySelector('input[value="' + chosen.w + '"]');
        if (si) si.checked = true;
        if (wi) wi.checked = true;
      } else if (splitPicked(splitSize) && splitPicked(splitWidth)) {
        // A colour change dropped the combination (not made in that colour): keep the width, ask for the size again.
        splitSize.querySelector('input[data-split-input]:checked').checked = false;
        splitDead = false;
      }
      var widthInputs = splitWidth.querySelectorAll('input[data-split-input]');
      if (widthInputs.length === 1) widthInputs[0].checked = true;
      var s = splitPicked(splitSize);
      var w = splitPicked(splitWidth);
      markSplit(splitSize, function (v) { return real.filter(function (r) { return r.s === v && (!w || r.w === w); }); });
      markSplit(splitWidth, function (v) { return real.filter(function (r) { return r.w === v && (!s || r.s === s); }); });
      setSplitLegend(splitSize, s);
      var wl = w && splitWidth.querySelector('input[value="' + w + '"]');
      setSplitLegend(splitWidth, wl ? wl.getAttribute('data-split-label') : null);
    }
    function markSplit(box, matches) {
      var ins = box.querySelectorAll('input[data-split-input]');
      for (var k = 0; k < ins.length; k++) {
        var list = matches(ins[k].value);
        var made = list.some(function (r) { return r.made; });
        var avail = list.some(function (r) { return r.made && !r.input.disabled; });
        var lab = labelFor(ins[k]);
        if (!lab) continue;
        lab.classList.toggle('is-unavailable', !avail);
        lab.classList.toggle('is-missing', !made);
        var sr = lab.querySelector('.vh');
        if (sr) sr.textContent = !made ? ', not made in this combination' : (!avail ? ', sold out' : '');
      }
    }
    function setSplitLegend(box, text) {
      var span = box.querySelector('[data-split-value]');
      if (span) span.textContent = text || 'Select';
    }
    function pickSplit(changed) {
      var s = splitPicked(splitSize);
      var w = splitPicked(splitWidth);
      var real = splitReal();
      var hit = null;
      for (var i = 0; i < real.length; i++) if (real[i].s === s && real[i].w === w && real[i].made) hit = real[i];
      // A struck-through size that isn't made in this colour/width reads "Sold out", the same as one that
      // is made but has no stock (2026-10-02, Craig: the two used to say different things).
      splitDead = !hit && !!s && !!w;
      for (var k = 0; k < real.length; k++) real[k].input.checked = real[k] === hit;
      update();
    }

    function applyUrl() {
      var params = new URLSearchParams(window.location.search);
      var id = Number(params.get('variant'));
      var target = null;
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) target = data.variants[i];
      var colorOnly = params.get('pick') === 'color';
      for (var o = 0; o < n; o++) {
        var ins = inputs(o);
        for (var k = 0; k < ins.length; k++) {
          if (!target) continue;
          if (o !== ci && (colorOnly || (!data.hasSelected && !params.get('variant')))) {
            if (ins.length > 1) ins[k].checked = false;
          } else {
            ins[k].checked = ins[k].value === target.o[o];
          }
        }
      }
    }

    // A struck-through size on a product without the size/width rows is a disabled radio, so clicking it did
    // nothing; say "Sold out" like the shoe rows do (2026-10-02).
    root.addEventListener('click', function (e) {
      var lab = e.target.closest && e.target.closest('label.opt__btn.is-unavailable');
      if (!lab) return;
      var inp = document.getElementById(lab.getAttribute('for'));
      if (!inp || !inp.disabled || inp.matches('[data-split-input]')) return;
      if (atc) { atc.disabled = true; atc.textContent = 'Sold out'; }
      if (statusEl) { statusEl.textContent = 'Sold out in this size'; statusEl.classList.remove('is-in'); }
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[data-option-input]')) { splitDead = false; update(); }
      else if (e.target.matches('input[data-split-input]')) pickSplit(e.target.getAttribute('data-split-input'));
    });

    // Initial: the server rendered the selected colour's gallery; just reconcile state.
    shownColor = ci > -1 ? selected()[ci] : null;
    if (new URLSearchParams(window.location.search).get('pick') === 'color') {
      applyUrl();
      shownColor = ci > -1 ? selected()[ci] : null;
    }
    update({ initial: true, noUrl: true });

    window.addEventListener('popstate', function () {
      if (!attached(root)) return;
      applyUrl();
      update({ noUrl: true });
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && attached(root)) { applyUrl(); update({ noUrl: true }); }
    });
  }

  /* -------------------------------------------------------- recommendations */

  function initRecommendations(section) {
    var url = section.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recs]');
      var ok = !!(fresh && fresh.querySelector('[data-color-card]'));
      section.innerHTML = ok ? fresh.innerHTML : '';
      section.hidden = !ok;
      if (ok) initFrames(section);
    }).catch(function () { section.hidden = true; });
  }

  /* -------------------------------------------------- men's / women's switch */

  var switchCache = {};
  var switching = false;
  var pendingPop = false;
  var announcer = null;

  // Compare products by handle, so collection-scoped and locale-prefixed URLs still match.
  function handleOf(path) {
    var m = /\/products\/([^\/?#]+)/.exec(path || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function announce(text) {
    if (!announcer) {
      announcer = document.createElement('p');
      announcer.className = 'vh';
      announcer.setAttribute('aria-live', 'polite');
      document.body.appendChild(announcer);
    }
    announcer.textContent = text;
  }

  // The other version's URL, keeping the chosen colour when that version makes it.
  function switchUrl(link) {
    var box = link.closest('[data-gender-switch]');
    var data = parseJson(box && box.querySelector('script[data-gender-json]'));
    var root = link.closest('[data-product-root]');
    var picked = root && root.querySelector('.opt--color input:checked');
    var id = data && picked && data.colors[picked.value.toLowerCase()];
    return link.getAttribute('href').split('?')[0] + (id ? '?variant=' + id + '&pick=color' : '');
  }

  function syncSwitchLinks(root) {
    var links = root.querySelectorAll('[data-gender-switch] [data-gender-link]');
    for (var i = 0; i < links.length; i++) links[i].setAttribute('href', switchUrl(links[i]));
  }

  function fetchSection(url, id) {
    var key = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
    if (!switchCache[key]) {
      switchCache[key] = fetch(key, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      switchCache[key].catch(function () { delete switchCache[key]; });
    }
    return switchCache[key];
  }

  // Replace this product section with the other version's, then re-run everything that
  // belongs to it. Any failure falls back to an ordinary page load of the same URL.
  function swapProduct(root, url, push) {
    var id = root.getAttribute('data-section-id');
    var holder = root.parentNode;
    if (!id || !holder || !window.fetch || !window.history || !window.history.pushState) {
      window.location.href = url;
      return;
    }
    if (switching) return;
    switching = true;
    var hadFocus = !!(document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-gender-switch]'));
    var before = parseJson(root.querySelector('script[data-product-json]'));
    var picked = root.querySelector('.opt--color input:checked');
    root.setAttribute('aria-busy', 'true');
    root.classList.add('is-switching');
    fetchSection(url, id).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-product-root]');
      if (!fresh) throw new Error('no product section in response');
      if (push) window.history.pushState({ outpostProduct: true }, '', url);
      holder.innerHTML = fresh.parentNode.innerHTML;
      var next = holder.querySelector('[data-product-root]');
      initProduct(next);
      syncSwitchLinks(next);
      var after = parseJson(next.querySelector('script[data-product-json]')) || {};
      if (before && before.title && after.title) document.title = document.title.replace(before.title, after.title);
      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical && after.url) canonical.href = new URL(after.url, window.location.href).href;
      var recs = document.querySelectorAll('[data-recs][data-url]');
      for (var r = 0; r < recs.length; r++) {
        recs[r].setAttribute('data-url', recs[r].getAttribute('data-url').replace(/([?&]product_id=)\d+/, '$1' + next.getAttribute('data-product-id')));
        initRecommendations(recs[r]);
      }
      if (hadFocus) {
        var current = next.querySelector('[data-gender-switch] [aria-current="page"]');
        if (current) current.focus({ preventScroll: true });
      }
      var kept = picked && next.querySelector('.opt--color input:checked');
      var note = picked && !(kept && kept.value.toLowerCase() === picked.value.toLowerCase()) ? ' ' + picked.value + ' is not made in this version.' : '';
      announce('Showing ' + (after.title || 'the other version') + '.' + note);
    }).catch(function () {
      window.location.href = url;
    }).then(function () {
      switching = false;
      if (attached(root)) { root.removeAttribute('aria-busy'); root.classList.remove('is-switching'); }
      if (pendingPop) { pendingPop = false; followHistory(); }
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-gender-switch] a');
    if (!link || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var root = link.closest('[data-product-root]');
    if (!root) return;
    e.preventDefault();
    if (link.getAttribute('aria-current') === 'page') return;
    swapProduct(root, switchUrl(link), true);
  });

  // Start fetching the other version as soon as the shopper points at, focuses or touches it.
  function warmSwitch(e) {
    var link = e.target.closest && e.target.closest('[data-gender-switch] [data-gender-link]');
    var root = link && link.closest('[data-product-root]');
    if (root && window.fetch) fetchSection(switchUrl(link), root.getAttribute('data-section-id')).catch(function () {});
  }
  document.addEventListener('mouseover', warmSwitch);
  document.addEventListener('focusin', warmSwitch);
  document.addEventListener('touchstart', warmSwitch, { passive: true });

  // A colour change also moves the other version's link, so opening it in a new tab keeps the colour.
  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.matches('.opt--color input') && e.target.closest('[data-product-root]');
    if (root) syncSwitchLinks(root);
  });

  // Back and forward between the two versions.
  function followHistory() {
    var root = document.querySelector('[data-product-root][data-section-id]');
    if (!root) return;
    var shown = handleOf(root.getAttribute('data-product-url'));
    var wanted = handleOf(window.location.pathname);
    if (!shown || !wanted || shown === wanted) return;
    if (switching) { pendingPop = true; return; }
    swapProduct(root, window.location.pathname + window.location.search, false);
  }
  window.addEventListener('popstate', followHistory);

  /* ------------------------------------------------------ filters + sorting */

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-facets-form]');
    if (!form || e.target.type === 'number') return;
    submitFacets(form);
  });
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-facets-form]')) {
      e.preventDefault();
      submitFacets(e.target);
    }
  });
  function submitFacets(form) {
    var params = new URLSearchParams();
    var fields = form.querySelectorAll('input, select');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!f.name || f.disabled || f.value === '') continue;
      if ((f.type === 'checkbox' || f.type === 'radio') && !f.checked) continue;
      params.append(f.name, f.value);
    }
    window.location.href = (form.getAttribute('action') || window.location.pathname) + (params.toString() ? '?' + params.toString() : '');
  }

  /* ------------------------------------------------------ predictive search */

  function initPredictive(wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var box = wrap.querySelector('[data-predictive-results]');
    if (!input || !box || !window.fetch) return;
    var timer = null;
    var controller = null;
    var active = -1;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', box.id);

    function options() { return box.querySelectorAll('[role="option"]'); }
    function close() {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function highlight(i) {
      var opts = options();
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      for (var k = 0; k < opts.length; k++) opts[k].setAttribute('aria-selected', k === active ? 'true' : 'false');
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    function search() {
      var q = input.value.trim();
      if (q.length < 2) { close(); box.innerHTML = ''; return; }
      if (controller && controller.abort) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = wrap.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,query,page,article&resources[limit]=6' +
        '&resources[options][prefix]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title,variants.sku,variants.barcode';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-predictive-inner]');
          box.innerHTML = inner ? inner.innerHTML : '';
          if (box.innerHTML.trim()) {
            box.hidden = false;
            input.setAttribute('aria-expanded', 'true');
            active = -1;
          } else {
            close();
          }
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'Enter' && active > -1) {
        var opt = options()[active];
        if (opt && opt.href) { e.preventDefault(); window.location.href = opt.href; }
      }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  }

  ready(function () {
    var products = document.querySelectorAll('[data-product-root]');
    for (var i = 0; i < products.length; i++) { initProduct(products[i]); syncSwitchLinks(products[i]); }
    var recs = document.querySelectorAll('[data-recs][data-url]');
    for (var r = 0; r < recs.length; r++) initRecommendations(recs[r]);
    var pred = document.querySelectorAll('[data-predictive]');
    for (var p = 0; p < pred.length; p++) initPredictive(pred[p]);
    initFrames(document);
  });

  window.OutpostColor = { selectCardColor: selectCardColor, stepCard: stepCard, money: money };
})();
